const numberFormatter = n => {
    if (isNaN(n)) n = parseFloat(n)
    let arr = n.toString().split('.')
    let prefix = ''
    if (arr[0].charAt(0) === '-') {
        prefix = '-'
        arr[0] = arr[0].substr(1)
    }
    let int = arr[0]
        .split('')
        .reverse()
        .join('')
    let aux = []
    for (let i = 0; i < int.length; i += 3) {
        aux.push(int.substr(i, 3))
    }
    arr[0] = aux
        .join('.')
        .split('')
        .reverse()
        .join('')
    return prefix + arr.join(',')
}

const currencyFormater = (n, c = '$') => `${c} ${numberFormatter(n)}`

const truncateAndRound = float => {
    float = ('' + float).split('.')
    if (float.length > 1) {
        float = float[0] + '.' + float[1].charAt(0)
    } else {
        float = float[0]
    }
    return Math.round(float)
}

const twoDecimalsFormat = float => {
    return Math.round(float * 100) / 100
}

const calcRoundingLaw = amount => {
    let mod = amount % 10
    if (mod < 6) {
        return mod * -1
    }
    return 10 - mod
}

export {
    numberFormatter,
    twoDecimalsFormat,
    truncateAndRound,
    calcRoundingLaw,
    currencyFormater,
}
